module.exports = __webpack_public_path__ + "img/roanoke-logo-dark.2dce9f74.png";